// src/experiments/experiments.config.js
//
// The experiment registry: the only place an experiment is defined. Entries
// are deliberately small. The hypothesis, the primary metric and the owner
// belong in the pull request that adds the experiment and in the runbook,
// not in the bundle.
//
//   key       [a-z0-9_]. Lands in analytics as `key:variant`.
//   traffic   0–1, the share of visitors enrolled. 0 means dormant: ship at 0
//             and start the test by raising it in the Firebase console, so a
//             start is never tied to a deploy we do not schedule. Raising only
//             adds people; lowering evicts, so lower it only to 0.
//   variants  Plain keys for an even split: ['control', 'b']. Objects when the
//             split is uneven: [{ key: 'control', weight: 0.8 }, ...]. The
//             first entry is control and is what crawlers always see. Never
//             change the variants once traffic has been above 0.
//
// Optional:
//   paths     URL prefixes the experiment applies on: ['/vehicleQuoteResults'].
//   products  PRODUCT_CONFIG keys, matched from the flow slug in the URL, so
//             quote steps only. Results and thank-you pages use `paths`.
//   device    'mobile' | 'tablet' | 'desktop', or a list of them.
//   group     One experiment with traffic above 0 per group at a time.
//             Defaults to the first product, else 'site'.
//
// Any other field fails validation (see experiments.config.test.js).

export const EXPERIMENTS = [
  // Worked example, dormant. Replace it with the first real experiment.
  {
    key: 'results_sort_v1',
    traffic: 0,
    variants: ['control', 'cheapest_first'],
    paths: ['/vehicleQuoteResults'],
    group: 'CarInsurance',
  },
];

// Send `X-Experiments` on API calls (see src/experiments/apiHeader.js). Off
// until the API's CORS allowlist and logging are confirmed: an unlisted header
// fails every cross-origin request at preflight.
export const SEND_EXPERIMENTS_HEADER = false;
